import { chakra } from '@plurall/elo-v3';

import { essaysTabsRootRecipe } from './essays-tabs.recipe';

export const EssaysTabsRootFactory = chakra('div', essaysTabsRootRecipe);
